import { CREATE_BASVURU_WITH_YIBFNO } from "../constants/requestUrls";

import { postRequest } from "../request";

const CreateBasvuruWithYibfNo = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
  return postRequest({ url: CREATE_BASVURU_WITH_YIBFNO, data });
}

export default CreateBasvuruWithYibfNo;